<template>
    <div class="page-container">
        <slot name="eyebrow"></slot>
        <div v-if="$slots.title || $slots.controls" class="title-and-controls">
            <slot name="title"></slot>
            <div class="controls">
                <slot name="controls"></slot>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<style lang="scss" scoped>
.page-container {
    margin: 0 auto;
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
}

.title-and-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;

    .controls {
        white-space: nowrap;
    }
}

@media screen and (max-width: 768px) {
    .title-and-controls {
        flex-direction: column;
        align-items: flex-start;

        :deep(.title-section) {
            margin-bottom: 1rem;
        }

        .controls {
            align-self: flex-end;
        }
    }
}
</style>
